import React, { useEffect, useRef, useState } from "react";
import useInView from "../hooks/useInView";

// Parses a formatted stat string like "$17M", "1M+", "150+", "5×"
// into { prefix, number, suffix } for animated counting.
const parseStat = (raw) => {
  const match = raw.match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
  if (!match) return { prefix: "", number: null, suffix: raw };
  return {
    prefix: match[1] || "",
    number: parseFloat(match[2]),
    suffix: match[3] || ""
  };
};

const CountUp = ({ value, durationMs = 1400, className, style }) => {
  const { prefix, number, suffix } = parseStat(value);
  const [ref, inView] = useInView({ threshold: 0.2 });
  const [display, setDisplay] = useState(number === null ? value : `${prefix}0${suffix}`);
  const startedRef = useRef(false);

  useEffect(() => {
    if (!inView || startedRef.current || number === null) return;
    startedRef.current = true;
    const start = performance.now();

    const tick = (now) => {
      const t = Math.min(1, (now - start) / durationMs);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - t, 3);
      const current = number * eased;
      const formatted =
        Number.isInteger(number) || number >= 100
          ? Math.round(current).toString()
          : current.toFixed(1);
      setDisplay(`${prefix}${formatted}${suffix}`);
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, number, prefix, suffix, durationMs]);

  return (
    <span ref={ref} className={className} style={style}>
      {display}
    </span>
  );
};

export default CountUp;
